<script>
  import {API_VILLAGE, API_EXPORT} from '../../common/api'
  import {rangeVillage} from '../../assets/js/funcs'
  import VillageAdd from './VillageAdd'
  import VillageUpdate from './VillageUpdate'
  import BaseList from '../BaseList'
  import axios from 'axios'

  export default {
    name: 'VillageList',
    extends: BaseList,
    data() {
      return {
        searchForm: {
          name: ''
        }
      }
    },
    created() {
      this.getDataList();
      this.tableHeight = window.innerHeight - 110;
    },
    methods: {
      // 小区列表接口
      getDataList() {
        this.loading = true;
        let params = {
          page_no: this.currentPage,
          page_num: 1000,
          name: this.searchForm.name
        };
        this.$http.GET(API_VILLAGE, params,
          res => {
            this.tableData = rangeVillage(res.result.list);
            this.totalCount = res.result.total;
            this.loading = false;

            if (this.searchForm.name.length == 0) {
              this.$store.commit('setVillage', res.result.list);
              this.$store.commit('setArrangeVillage', rangeVillage(res.result.list));
            }
          }, err => {
            this.loading = false;
            this.$message.error(err.msg);
          })
      },
      deleteVillage(id) {
        this.$confirm('此操作将永久删除该小区, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.DELETE(API_VILLAGE + '/' + id, null,
            res => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getVillageList()
            }, err => {
              this.$message.error(err.msg)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      print(village_id, company_id, name) {
        let params = new URLSearchParams();
        params.append('village_id', village_id);
        params.append('company_id', company_id);
        axios.post(API_EXPORT, params, {responseType: 'blob'}).then((res) => {
          console.log(res.data);
          const link = document.createElement('a');
          let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);

          link.setAttribute('download', name + '_用户列表.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link)
        });
      },

      // 设置表格高度
      setTableHeight() {
        this.tableHeight = window.innerHeight - 110
      },
    },
    components: {
      VillageAdd,
      VillageUpdate
    }
  }
</script>

<template>
  <div class="main">
    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      size="small"
      row-key="id"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      :height="tableHeight"
      border>
      <!--<el-table-column label="小区名称" prop="name"></el-table-column>-->
      <el-table-column label="小区名称">
        <template slot-scope="{row}">
          {{row.name}}
          <span style="color: red">{{ row.user_count == 0 ? '' : '( ' + row.user_count+' )户' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="300px">
        <template slot-scope="{row}">
          <el-tooltip class="operate_item" effect="dark" content="修改" placement="top">
            <i class="iconfont icon-bianji operate_font" @click="showUpdate(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="导出" placement="top">
            <i class="iconfont icon-daochu operate_font" @click="print(row.id, row.company_id, row.name)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination_view">
      <label>共{{ this.totalCount }}条</label>
    </div>

    <el-dialog
      title="新增小区"
      v-if="addDialogVisible"
      :visible.sync="addDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <village-add @addVillageSuccess="addSuccess"></village-add>
    </el-dialog>

    <el-dialog
      title="修改小区"
      v-if="updateDialogVisible"
      :visible.sync="updateDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <village-update :village_id="this.operateId" @updateVillageSuccess="updateSuccess"></village-update>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

  .main {
    padding: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/page/village/VillageList.vue